import React from "react";
import ReactDOM from "react-dom/client";
import Index from "./Index.tsx";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    <Index />
  </React.StrictMode>,
);
